
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M52.2 108.6c-.2-.4-.2-.8-.2-1.1.1-.3-.1-.5-.6-.7-.4-.2-.7-.3-.7-.5 0-.1-.3-.2-.9-.2-.5-.1-.8-.1-.8-.1H23.5c-3.6 0-6.7-1.3-9.2-3.9-2.6-2.6-3.8-5.7-3.8-9.3V35.1c0-3.6 1.3-6.7 3.8-9.3 2.6-2.6 5.6-3.9 9.2-3.9h26.1c.7 0 1.3-.2 1.7-.5.4-.4.7-.9.8-1.6.1-.7.2-1.4.2-1.9v-2.2c-.1-.9-.1-1.4-.1-1.6 0-.7-.3-1.3-.8-1.8s-1.1-.8-1.8-.8H23.5c-6.5 0-12 2.3-16.6 6.9C2.3 23.1 0 28.6 0 35.1v57.7c0 6.5 2.3 12.1 6.9 16.7 4.6 4.6 10.1 6.9 16.6 6.9h26.1c.7 0 1.3-.2 1.7-.5.4-.4.7-.9.8-1.6.1-.7.2-1.4.2-1.9v-2.2c0-.8-.1-1.4-.1-1.6z"}}),_c('path',{attrs:{"d":"M126.4 60.3L82 15.7c-1-1-2.3-1.6-3.7-1.6-1.4 0-2.6.5-3.7 1.6-1 1-1.6 2.3-1.6 3.7V43H36.6c-1.4 0-2.6.5-3.7 1.6-1 1-1.6 2.3-1.6 3.7v31.5c0 1.4.5 2.7 1.6 3.7 1 1 2.3 1.6 3.7 1.6h36.6v23.6c0 1.4.5 2.7 1.6 3.7 1 1 2.3 1.6 3.7 1.6 1.4 0 2.6-.5 3.7-1.6l44.4-44.6c1-1 1.6-2.3 1.6-3.7-.2-1.5-.7-2.8-1.8-3.8z"}})])
          )
        }
      }
    